import React, { useState} from 'react'
import { ContainerButtons, WrapperButtons, Container, Tooltip, ButtonOpenClose, Wrapper } from './menu-actions.styled.component'
import { MdVolumeMute, MdFullscreen, MdFullscreenExit, RiShareLine } from 'react-icons/all'
import { VscMute } from 'react-icons/all'
import { IconVR } from '../../components/fontawesome'
import { setAudioMuted } from '../sound-player'
import { VscChevronUp as ArrowButton } from 'react-icons/vsc'

const MenuActionsMobileComponent = ({ onClickVR }) => {
  const [fullScreen, setFullScreen] = useState(false)
  const [showMuted, setShowMuted] = useState(false)
  const [ showTootip, setShowTooltip ] = React.useState(false);
  const [ isOpen, setIsOpen ] = useState(false);
  
  const activeFullScreen = () => {
    setFullScreen(!fullScreen)
    const el = document.documentElement;
    if(fullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    } else {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) { /* Safari */
        el.webkitRequestFullscreen();
      } else if (el.msRequestFullscreen) { /* IE11 */
        el.msRequestFullscreen();
      }
    }
  }

  return (
    <Container>
      {showTootip && <Tooltip>copied to clipboard</Tooltip>}
      <Wrapper>
        <ButtonOpenClose onClick={() => setIsOpen(() => !isOpen)}>
          <ArrowButton className={`button-collapse ${isOpen ? 'open': ''}`} color="#FFF" size={22} />
        </ButtonOpenClose>
        <WrapperButtons className={`${isOpen ? 'open': ''}`}>
          <ContainerButtons className={`${isOpen ? 'open': ''}`}>
            {
              showMuted ?
              <VscMute
                style={{ paddingLeft: '2px' }}
                onClick={() => {
                  setShowMuted(!showMuted)
                  setAudioMuted(false)
                }}
                fill='#fff'
                strokeWidth='1px'
                stroke="transparent"
                size='1.4em' /> :
              <MdVolumeMute
                onClick={() => {
                  setShowMuted(!showMuted)
                  setAudioMuted(true)
                }}
                fill='none'
                stroke='#fff'
                strokeWidth='1px'
                size='1.4em' />
            }
            {
              fullScreen ? 
              <MdFullscreenExit onClick={() => activeFullScreen()} fill='#fff' size='1.3em' /> : 
              <MdFullscreen onClick={() => activeFullScreen()} fill='#fff' size='1.3em' />
            }
            <RiShareLine
              onClick={() => {
                if(showTootip) return;
                navigator.clipboard.writeText(`${window.location.href}`)
                setShowTooltip(true);
                if(!showTootip) setTimeout(() => {
                  setShowTooltip(false);
                }, 3100)
              }}
              color={'rgba(255,255,255, .7)'}
              size='1.02em' />
            <IconVR onClick={() => onClickVR()}/>
            
          </ContainerButtons>
        </WrapperButtons>
      </Wrapper>
    </Container>
  )
};

export default MenuActionsMobileComponent;
